
















































































































































import Vue, { PropType } from "vue";
import VaCard from "../molecules/VaCard.vue";
import { ReleaseNotes } from "@/models/releaseNotes";
import VaButton from "../atoms/VaButton.vue";
import { VDialog } from "vuetify/lib";
import FileUtil from "@/utils/fileUtil";

export default Vue.extend({
  name: "SoftwareVersionRow",
  components: { VaCard, VaButton, VDialog },
  data() {
    return {
      downloading: false,
      dialog: false,
      changelogText: "",
      changelogTitle: "",
    };
  },

  props: {
    icon: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    note1: {
      type: Object as PropType<ReleaseNotes>,
      required: false,
    },
    note2: {
      type: Object as PropType<ReleaseNotes>,
      required: false,
    },
  },
  methods: {
    showNotes(note: ReleaseNotes): void {
      this.changelogText = note.releaseNotes;
      this.changelogTitle = note.title;
      this.dialog = true;
    },
    async download(url: string): Promise<void> {
      this.downloading = true;
      try {
        if (url !== "") FileUtil.download(url);
      } catch (e) {
        this.$notification.error(e);
      } finally {
        this.downloading = false;
      }
    },
  },
  computed: {},
});
